// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class OrchMedicalCardFinderResponseModel {
    'transactionId'?: string | null;
    'transactionCorrelationId'?: number;
    'transactionDateTime'?: Moment;
    'transactionMessage'?: string | null;
    'transactionStatus'?: boolean;
    'isGeWhiteListed'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof OrchMedicalCardFinderResponseModel>> = [
        {
            "name":     "transactionId",
            "baseName": "transactionId",
            "type":     "string"
        },
        {
            "name":     "transactionCorrelationId",
            "baseName": "transactionCorrelationId",
            "type":     "number"
        },
        {
            "name":     "transactionDateTime",
            "baseName": "transactionDateTime",
            "type":     "Date"
        },
        {
            "name":     "transactionMessage",
            "baseName": "transactionMessage",
            "type":     "string"
        },
        {
            "name":     "transactionStatus",
            "baseName": "transactionStatus",
            "type":     "boolean"
        },
        {
            "name":     "isGeWhiteListed",
            "baseName": "isGeWhiteListed",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return OrchMedicalCardFinderResponseModel.attributeTypeMap;
    }
}
